export default __webpack_public_path__ + "static/media/EuropeanAsh.8ba22af5.jpg";